import {skills_long, skills_short } from '../../dmView/constants.js';


function extractAc(jsonData) {
    return jsonData?.definition?.armorClass || 0;
}

export const getSkillDetails = (data) => {
    // if old background (no mod) and new race (no mod) = allow racial mod
    // if old background (no mod) and old race (mod) = allow racial mod

    // if NEW background (mod) and old race (mod) = DONT allow racial mod
    // if NEW background (mod) and NEW race (no mod) = DONT allow racial mod
    // ignore racial skill mods if new background is from a newer source i.e. sourceId is greater then 2
    let ignoreRace = false;
    data?.background?.definition?.sources?.forEach(source => {
        if(source?.sourceId > 2) {
            ignoreRace = true
        }
    })

    let newBaseACMods = []
    let bonusAc = 0
    let bonusInitMods = []
    let bonusHpPerLevel = 0
    let bonuses = {
        "race": [0, 0, 0, 0, 0, 0],
        "class": [0, 0, 0, 0, 0, 0],
        "background": [0, 0, 0, 0, 0, 0],
        "item": [0, 0, 0, 0, 0, 0],
        "feat": [0, 0, 0, 0, 0, 0],
        "set": [0, 0, 0, 0, 0, 0]
    }

    Object.entries(data.modifiers).forEach(([key, modsArray]) => {
        // Skip race
        if(ignoreRace && key === 'race') {
            console.log("2024 background found... Ignoring Old Racial Mods (if present)")
            return
        }

        //1789132
        //This modTypeArray is - class - race - feat - item - which is the key
        modsArray.forEach(mod => {
            if(mod["type"] === "bonus") {
                let fSubtypeName = mod["friendlySubtypeName"]
                // Check if its a skill increase "Strength Score", "Dexterity Score" etc
                let indexOfMatch = skills_long.indexOf(fSubtypeName)
                if(indexOfMatch !== -1) {
                    bonuses[key][indexOfMatch] += mod["fixedValue"]
                } else if(fSubtypeName === 'Armored Armor Class' || fSubtypeName === 'Armor Class') {
                    // Get AC bonus from feats, class...
                    bonusAc += mod["fixedValue"]
                } else if(fSubtypeName === 'Hit Points per Level') {
                    bonusHpPerLevel += mod["fixedValue"]
                } else if(fSubtypeName === 'Initiative' && mod.statId !== null) { 
                    // This is the index of the stat, but dndb does not 0 index
                    // so 1 is STR ... where it should be 0
                    bonusInitMods.push(mod["statId"]-1);
                }
            } else if(mod["type"] === "set") {
                // Unarmored Armor Class but fixedValue is null
                let fSubtypeName = mod["friendlySubtypeName"]
                if(fSubtypeName === 'Unarmored Armor Class') {
                    console.log("Specific Unarmored Armor Class mod component id:", mod["componentId"])
                    // Dazzling footwork - Bard - no armor and no sheild, AC = 10 + DEX mod + CHA mod
                    // Draconic Resilience footwork - Sorceror
                    if(mod["componentId"] === 10292523 || mod["componentId"] === 10292944) {
                        newBaseACMods.push('DEX');
                        newBaseACMods.push('CHA');
                    // Unarmored Defense - Monk - no armor and no sheild, AC = 10 + DEX mod + WIS mod
                    } else if(mod["componentId"] === 10292257) {
                        newBaseACMods.push('DEX');
                        newBaseACMods.push('WIS');
                    // x2 Unarmored Defense - Barb - no armor and no sheild, AC = 10 + DEX mod + CON mod
                    } else if(mod["componentId"] === 10292151 || mod["componentId"] === 52) {
                        newBaseACMods.push('DEX');
                        newBaseACMods.push('CON');
                    }
                    
                    // Get AC bonus from feats, class...
                    bonusAc += mod["fixedValue"] 
                } else if(mod['subType'].includes('-score')) {
                    console.log("Skill Override added:", key, mod['subType'])
                    // For When skill Overrides are found i.e. Set Constitution to 19
                    // Check later if skill is less then this
                    let skillIndex = mod['entityId']-1
                    bonuses.set[skillIndex] = mod['value']
                }
            }  
        })
    })


    let skills_json_array = [];
    for (let i = 0; i < 6; i++) {
        let skill = {
            "skill": skills_short[i],
            "base": data["stats"][i]["value"],
            "race":       bonuses['race'][i],
            "class":      bonuses['class'][i],
            "background": bonuses['background'][i],
            "item":       bonuses['item'][i],
            "feat":       bonuses['feat'][i]
        };

        let userBonusValue = data["bonusStats"][i].value || 0
        let overRideValue = data["overrideStats"][i].value

        if(overRideValue) {
            skill["total score"] = overRideValue
        } else {
            skill["total score"] = 
                skill["base"] +
                skill["race"] +
                skill["class"] +
                skill["background"] +
                skill["item"] +
                skill["feat"] + 
                userBonusValue;
        }

        // Add the override if better then the previous total
        if(bonuses['set'][i] > skill['total score']) {
            console.log("Override skill from bonus.set @", i)
            skill['total score'] = bonuses.set[i]
        } 


        // either use the overRideValue if present, or get the total score + bonus values set by the user
        skill["modifier"] = Math.floor((skill["total score"] - 10) / 2);

        // console.table({
        //     "bonus": userBonusValue,
        //     "override": overRideValue,
        //     "total mod": skill["modifier"],
        // })
        skills_json_array.push(skill);
    }

    let total_lvl = 0;
    data["classes"].forEach(classDND => {
        total_lvl += classDND["level"];
    });
    
    // bonusHpPerLevel comes from races, mods, and other sources with the "Hit Points per Level" friendlySubtypeName
    let bonusHp = bonusHpPerLevel * total_lvl;
    let baseHp = data["baseHitPoints"];
    let maxHp = (skills_json_array[2]["modifier"] * total_lvl) + baseHp + bonusHp;

    if (data.overrideHitPoints) {
        maxHp = data.overrideHitPoints
    }

    // Bonushp is maxHP modifier 
    if (data.bonusHitPoints) {
        maxHp += data.bonusHitPoints
    }

    // =================
    // let nakedArmorClass = 10 + skills_json_array[1].modifier;
    let armorClass = bonusAc; // Start with AC from class/feat modifiers
    let shieldAcOnDexSaves = { shieldAc: 0, active: false, restrictions: [] };
    data.modifiers.feat.forEach(mod => {
        if (mod.type === "bonus") {
            if (mod.subType === "shield-ac-on-dex-saves") {
                shieldAcOnDexSaves.active = true;
                shieldAcOnDexSaves.restrictions = mod.restriction;
            }
        }
    });

    data.inventory.sort((a, b) => extractAc(b) - extractAc(a));

    let overRideArmor = false;
    if(data.characterValues) {
        data.characterValues.forEach(value => {
            if(value.typeId === 1) {
                armorClass = value.value
                overRideArmor = true
            }
        })
    }

    let shield = false;
    let armor = false;
    let inventory = [];
    let modsFromItems = [];
    const armorTypeKey = {
        0: "none",
        1: "light",
        2: "medium",
        3: "heavy",
    }
    let armorType = "none"

    data.inventory.forEach(item => {
        let itemDef = item.definition;
        let itemDictionary = {
            name: itemDef.name,
            attackType: itemDef.attackType,
            damage: itemDef.damage,
            damageType: itemDef.damageType,
            type: itemDef.type,
            description: itemDef.description,
            range: itemDef.range,
            longRange: itemDef.longRange,
            equipped: itemDef.equipped,
            quantity: itemDef.quantity,
            isAttuned: itemDef.isAttuned,
        };

        if (itemDef.properties) {
            let properties = itemDef.properties.map(prop => {
                let itemProp = {
                    name: prop.name,
                    description: prop.description
                };
                if (prop.notes) {
                    itemProp.notes = prop.notes;
                }
                return itemProp;
            });
            itemDictionary.properties = properties;
        }

        let grantedModsArray = itemDef.grantedModifiers.map(grantedMod => ({
            id: grantedMod.id,
            fixedValue: grantedMod.fixedValue,
            dice: grantedMod.dice,
            restriction: grantedMod.restriction,
            type: grantedMod.type,
            subType: grantedMod.subType
        }));

        itemDictionary.grantedModifiers = grantedModsArray;

        if(!overRideArmor && item.equipped) {
            // If no current sheild and this item is a sheild then add AC 
            if (!shield && item.definition.baseArmorName === "Shield") {
                shield = true;
                armorClass += item.definition.armorClass;
                // AC from sheild
                if (shieldAcOnDexSaves.active) {
                    shieldAcOnDexSaves.shieldAc = item.definition.armorClass;
                }
            } else if (!armor && item.definition.filterType.toLowerCase().includes("armor")) {
                armor = true;
                // AC from armor
                armorClass += item.definition.armorClass;
                armorType = armorTypeKey[item.definition.armorTypeId]
            } else if (itemDictionary.grantedModifiers.length > 0) {
                modsFromItems.push(itemDictionary.grantedModifiers);
            }
        }
        
        inventory.push(itemDictionary);
    });

    modsFromItems.forEach(itemMods => {
        itemMods.forEach(mod => {
            if(mod.subType === 'armor-class') {
                console.log(`AC Granted from item (${mod.fixedValue})`)
                armorClass += mod.fixedValue
            }
        })
    })

    
    if(!overRideArmor) {
        if(armor) {
            // Only add dex mod to ac is not wearing heavy armor
            if(armorType !== "heavy") {
                // Base AC already set by armor above
                armorClass += skills_json_array[1].modifier
            } 
        // Add the default 10 + DEX if no armor and other bonuses
        } else {
            armorClass += 10 + skills_json_array[1].modifier
            // No armor or sheild of Unarmored Defense
            if(!shield) {
                newBaseACMods.forEach(newAcModName => {
                    // Dex already added in: skills_json_array[1].modifier
                    if(newAcModName !== "DEX") {
                        let baseAcModIndex = skills_short.indexOf(newAcModName)
                        armorClass += skills_json_array[baseAcModIndex].modifier
                    }
                });
            }
        }
    }

    // Adds bonuses to initiative from other skills i.e. Init bonus equals your WIS mod
    if(bonusInitMods.length > 0) {
        bonusInitMods.forEach(skillIndex => {
            // add to dex so initative is later calculated - AC and other things are already calced above 
            skills_json_array[1]["total score"] += skills_json_array[skillIndex].modifier*2
        })
    }
    return {maxHp, armorClass, inventory, skills_json_array};
};

export default getSkillDetails;



